module.exports = __webpack_public_path__ + "static/testimonial-thumb-4-7f90de07ea3369a6250a09d3990c1b67.jpg";